// @ts-nocheck
import { catchAsync, paramsSerializer } from '../utils/api';
import axios from '../utils/axios';
import { ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT, ONLINE_REPORT_SERVICE_API_ENDPOINT } from '../config';

const massUpdatePlayers = catchAsync(async (actionType, data) => {
    const result = await axios.post(
        `${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/player-mass-update?actionType=${actionType}`,
        data,
    );

    return result.data;
});

export const getPlayerDetails = catchAsync(async accountNumber => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/player-details/general/${accountNumber}`);

    return result.data;
});

const getPlayerSegments = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment`, { params });

    return result.data;
});

const getPlayerSegment = catchAsync(async id => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment/${id}`);

    return result.data;
});

const createPlayerSegment = catchAsync(async data => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment`, data);

    return result.data;
});

const updatePlayerSegment = catchAsync(async (id, data) => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment/${id}`, data);

    return result.data;
});

const deletePlayerSegment = catchAsync(async id => {
    const result = await axios.delete(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment/${id}`);

    return result.data;
});

const getPlayerSegmentReport = catchAsync(async (params = {}) => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/player-segments`, { params });

    return result.data;
});

export const getFinancialTransactionsSummary = catchAsync(async params => {
    const query = paramsSerializer(params);

    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/financial/transaction/summary?${query}`);

    return result.data;
});

export const getFinancialTransactionsDetailed = catchAsync(async params => {
    const query = paramsSerializer(params);

    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/financial/transaction/details?${query}`);

    return result.data;
});

export const getFinancialTransactionsPendingWithdrawals = catchAsync(async params => {
    const query = paramsSerializer(params);

    const result = await axios.get(
        `${ONLINE_REPORT_SERVICE_API_ENDPOINT}/financial/transaction/pending-withdrawals?${query}`,
    );

    return result.data;
});

export const getFinancialTransactionsKPI = catchAsync(async params => {
    const query = paramsSerializer(params);

    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/financial/transaction/kpi?${query}`);

    return result.data;
});

export const getProfitsAndLosses = catchAsync(async params => {
    const query = paramsSerializer(params);

    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/sport-performance-reports/v2?${query}`);

    return result.data;
});

export const updateVerificationStatuses = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts/update-verification`, data);

    return result.data;
});

export const updateCommunicationPreferences = catchAsync(async data => {
    const result = await axios.put(
        `${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts/update-communication-preferences`,
        data,
    );

    return result.data;
});

export const getPaymentAccounts = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/payment-order/management?${query}`);

    return result.data;
});

export const getDocuments = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/document-management?${query}`);

    return result.data;
});

export const deleteDocument = catchAsync(async ({ id, comment }) => {
    const query = paramsSerializer({ id });
    const result = await axios.delete(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/document-management?${query}`, {
        data: {
            comment,
        },
    });

    return result.data;
});

export const updateDocument = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/document-management`, data);

    return result.data;
});

export const uploadDocuments = catchAsync(async formData => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/document-management`, formData);

    return result.data;
});

export const getMessageThreads = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/communication/all-chat/?${query}`);

    return result.data;
});

export const getMessageThreadById = catchAsync(async id => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/communication/chat/${id}`);

    return result.data;
});

export const sendNewMessage = catchAsync(async data => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/communication/new`, data);

    return result.data;
});

export const replyToMessage = catchAsync(async data => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/communication/reply`, data);

    return result.data;
});

export const getNotes = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/note/all?${query}`);

    return result.data;
});

export const getNoteById = catchAsync(async id => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/note/${id}`);

    return result.data;
});

export const createNote = catchAsync(async data => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/note`, data);

    return result.data;
});

export const updateNote = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/note`, data);

    return result.data;
});

export const deleteNote = catchAsync(async id => {
    const result = await axios.delete(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/note/delete/${id}`);

    return result.data;
});

export const changePassword = catchAsync(async data => {
    const result = await axios.patch(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts/change-password`, data);

    return result.data;
});

export const unblockAccount = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts/unblock`, data);

    return result.data;
});

export const updatePlayerInformation = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts`, data);

    return result.data;
});

export const updatePlayerBalance = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/balance-update`, data);

    return result.data;
});

export const changeFrozenStatus = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/balance-update`, data);

    return result.data;
});

export const createDepositLimit = catchAsync(async params => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/deposit-limit`, params);

    return result.data;
});

export const getSelfExclusions = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/self-exclude/${params}`);

    return result.data;
});

export const selfExclusion = catchAsync(async params => {
    const result = await axios.patch(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/self-exclude/${params.actionType}`, {
        accountNumber: params.accountNumber,
        comment: params.comment,
    });

    return result.data;
});

export const getDepositLimit = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/deposit-limit?accountNumber=${params}`);

    return result.data;
});

export const deleteDepositLimit = catchAsync(async accountNumber => {
    const result = await axios.delete(
        `${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/deposit-limit?accountNumber=${accountNumber}`,
    );

    return result.data;
});

export const changeManualSegment = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment/manual`, data);

    return result.data;
});

export const returnToAutomaticSegment = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment/automatic`, null, { params });

    return result.data;
});

export const bulkSegmentUpdate =catchAsync(async formData => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/segment/manual-csv`, formData);

    return result.data;
});

export const updateDocumentNumber = catchAsync(async data => {
    const response = await axios.patch(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/document-management`, data);

    return response.data;
});

export const blockUserBonus = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts/bonus-block`, data);

    return result.data;
});

export const unblockUserBonus = catchAsync(async data => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts/bonus-unblock`, data);

    return result.data;
});

const PlayerService = {
    massUpdatePlayers,
    getPlayerDetails,
    getPlayerSegmentReport,
    getPlayerSegments,
    getPlayerSegment,
    createPlayerSegment,
    updatePlayerSegment,
    deletePlayerSegment,
    changePassword,
    unblockAccount,
    updatePlayerInformation,
    updatePlayerBalance,
    changeFrozenStatus,
    getProfitsAndLosses,
    getFinancialTransactionsSummary,
    getFinancialTransactionsDetailed,
    getFinancialTransactionsPendingWithdrawals,
    getFinancialTransactionsKPI,
    updateVerificationStatuses,
    updateCommunicationPreferences,
    getPaymentAccounts,
    getDocuments,
    deleteDocument,
    updateDocument,
    uploadDocuments,
    getMessageThreads,
    getMessageThreadById,
    sendNewMessage,
    replyToMessage,
    getNotes,
    getNoteById,
    createNote,
    updateNote,
    deleteNote,
    createDepositLimit,
    getSelfExclusions,
    selfExclusion,
    getDepositLimit,
    deleteDepositLimit,
    changeManualSegment,
    returnToAutomaticSegment,
    bulkSegmentUpdate,
    updateDocumentNumber,
    blockUserBonus,
    unblockUserBonus,
};

export default PlayerService;
